import { ReportEntry } from '../../../../../../domain/report/ReportEntry';
import { DerivedDataObject } from 'react-table';

export const reportRefLot = (reportEntry: ReportEntry | DerivedDataObject): string =>
  reportEntry.refLot + ' : ' + reportEntry.lot;
